import { createEntityAdapter } from '@reduxjs/toolkit';

import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { getDetailedQuotes } from './investmentsQuotesDetailedThunks';
import {
  type DetailedQuote,
  INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY,
  type InvestmentsQuotesDetailedStoreState,
} from './investmentsQuotesDetailedTypes';
import { keyFromQuote } from './investmentsQuotesDetailedUtils';

const investmentsQuotesDetailedAdapter = createEntityAdapter<DetailedQuote, string>({
  selectId: keyFromQuote,
});

const initialState: InvestmentsQuotesDetailedStoreState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
} satisfies InvestmentsQuotesDetailedStoreState;

export const investmentsQuotesDetailedSlice = createAppSlice({
  name: INVESTMENTS_QUOTES_DETAILED_REDUCER_KEY,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDetailedQuotes.pending, (state, _action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getDetailedQuotes.fulfilled, (state, action) => {
      state.isLoading = false;
      investmentsQuotesDetailedAdapter.setMany(state, action.payload);
      state.loadPending = false;
    });
    builder.addCase(getDetailedQuotes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message ?? 'Failed to fetch detailed quotes';
      assert(!action.error, 'getDetailedQuotes.rejected', action.error);
    });
  },
});

export default investmentsQuotesDetailedSlice;
